// Image imports
import ofirLiebsteinPhoto from '../../../images/ofir_liebstein_photo.jpg';

export const ofirLiebsteinMemorial = {
  id: 9,
  name: 'Ofir Liebstein',
  category: 'community-leaders',
  images: {
    portrait: ofirLiebsteinPhoto
  },
  info: `

"In death, as in life, Ofir was an exemplar of an ethical public figure fighting for his residents, even if it endangered his life." - Shai Hajaji, head of Merhavim Regional Council

![Ofir Liebstein](${ofirLiebsteinPhoto})
*Ofir Liebstein, a dedicated leader who gave his life defending his community*

## A Life of Service

Ofir Liebstein, 50, was the head of the Sha'ar Hanegev Regional Council and a member of its local security team. He served in this position for five years, dedicating his life to the betterment of his community and building relationships both locally and internationally.

## The Tragic Day

On October 7, 2023, Ofir was killed during fighting with Hamas terrorists in Kibbutz Kfar Aza. True to his character, he was among the first to respond to the attack, rushing to defend the residents of his council.

## A Leader Remembered

Ofir was known for his:

- Dedication to his community
- Efforts to build connections between his region and neighbors in Gaza
- Positive attitude and infectious laugh
- Strong relationships with international supporters of Gaza border communities

San Diego Mayor Todd Gloria, whose city was a sister city with Sha'ar Hanegev, paid tribute to Ofir:

> "His enthusiasm for building connections between his city and neighbors in Gaza was inspiring. Ofir was a friend and the news of his death is absolutely heartbreaking."

Dan Springer, the CEO of JNF Australia, remembered Ofir as:

> "A great friend and a wonderful partner on many projects throughout Sha'ar HaNegev... always smiling, always positive, with a unique and infectious laugh."

## Legacy of Leadership

Ofir's death is a profound loss not only for his family but for the entire Sha'ar Hanegev community. His courage in the face of danger and his commitment to his people serve as an inspiration to all who knew him and those who learn of his story.

As we remember Ofir Liebstein, we are reminded of the selflessness of community leaders who put their lives on the line to protect those they serve. May his memory be a blessing and a call to continue his work of building bridges and fostering peace.

[Read more about Ofir Liebstein](https://october7memorial.com/memoriam/ofir-liebstein)

[Learn about Ofir's final moments](https://www.timesofisrael.com/ofir-libstein-50-head-of-local-council-killed-defending-town/)

`
};